import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const contactrole = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/organization/{profile}/contact-role',
    app: 'organization'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'organization', model: 'contactrole' }
    ),
    { }
  )
)()

export { contactrole, TYPES }
